"use client";

import { useState } from "react";
import LocationDropdownItem from "./location-dropdown-item";
import type { CampaignLocationT } from "./campaign-location-list";

interface OfferLocationListProps {
  locations: CampaignLocationT[];
}

/**
 * Reusable component for displaying offer locations in an expandable accordion format.
 * Each location can be expanded to show detailed contact information.
 */
export default function OfferLocationList({
  locations,
}: OfferLocationListProps) {
  const [expandedLocationId, setExpandedLocationId] = useState<string | null>(
    null
  );

  return (
    <div className="space-y-4">
      {locations.map((location) => (
        <LocationDropdownItem
          key={location.id}
          location={location}
          isExpanded={expandedLocationId === location.id}
          onToggle={() =>
            setExpandedLocationId(
              expandedLocationId === location.id ? null : location.id
            )
          }
        />
      ))}
    </div>
  );
}
